/* eslint-disable */
export const headers = [
    {
      text: 'Date',
      alignment: 'center',
      sortable: false,
      key: 'date'
    },
    {
      text: 'Invoice Number',
      alignment: 'center',
      sortable: false,
      key: 'invoice'
    },
    {
      text: 'Amount',
      alignment: 'center',
      sortable: false,
      key: 'amount'
    },
    {
      text: 'Status',
      alignment: 'center',
      sortable: false,
      key: 'status'
    }
  ];
  
  export const data = [
    {
      date: 'Jan 1, 2022',
      invoice: 'INV001234',
      amount: 'NGN 34,000',
      status: 'Pending',
    },
    {
        date: 'Jan 1, 2022',
        invoice: 'INV001234',
        amount: 'NGN 34,000',
        status: 'Paid',
    }
  ];
  